import { Box } from '@chakra-ui/react'

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  type?: 'auth' | 'submission'
}

const Spinner: React.FC<SpinnerProps> = ({ size = 'md', type = 'auth' }) => {
  let spinnerSize
  let thickness

  switch (size) {
    case 'sm':
      spinnerSize = '1.5rem'
      thickness = '3px'
      break
    case 'md':
      spinnerSize = '4rem'
      thickness = '8px'
      break
    case 'lg':
      spinnerSize = '8rem'
      thickness = '12px'
      break
  }

  return <Box sx={loaderStyles({ spinnerSize, thickness, type })} />
}

interface LoaderStylesProps {
  spinnerSize: string
  thickness: string
  type: 'auth' | 'submission'
}

const loaderStyles = ({ spinnerSize, thickness, type }: LoaderStylesProps) => ({
  border: `${thickness} solid`,
  borderColor: 'paleWhite',
  borderTopColor: type === 'auth' ? 'cardinal' : 'paleWhite',
  borderBottomColor: 'gold',
  borderRadius: '50%',
  width: spinnerSize,
  height: spinnerSize,
  animation: 'spin 1s linear infinite',
  display: 'inline-block',
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
})

export default Spinner
